import useRoute from 'hooks/useRoute';
import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import UserProfileDialog from './UserProfileDialog';

export function userDialogUrl(baseURL: string, cwUserId: UUID) {
  return `${baseURL}/users/${cwUserId}`;
}

export default function UserProfileDialogRoute() {
  const match = useRouteMatch();
  const { push } = useRoute();

  return (
    <Route
      path={`${match.path}/users/:cwUserId`}
      render={routeProps => (
        <UserProfileDialog cwUserId={routeProps.match.params.cwUserId} onClose={() => push(match.url)} />
      )}
    />
  );
}
